import type { PropsWithChildren, ReactNode } from 'react';
import cx from 'clsx';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { Placeholder } from './internals/placeholder';
import styles from './address-placeholder.module.css';

interface AddressLabelPlaceholderProps {
  addressType: 'merchant' | 'client';
}

export function AddressLabelPlaceholder({
  addressType,
  children,
}: PropsWithChildren<AddressLabelPlaceholderProps>): ReactNode {
  const { showPlaceholder } = usePlaceholders(
    addressType === 'merchant' ? PLACEHOLDERS.MerchantName : PLACEHOLDERS.ClientName
  );

  if (showPlaceholder) {
    return (
      <div className={cx(styles.label, 'mb-8')}>
        <Placeholder height="11px" width="153px" />
      </div>
    );
  }

  return <>{children}</>;
}
